import React, { Component } from "react";
import { Card, Row, Col, Tooltip } from "antd";
import { Fragment } from "react";
import moment from "moment";
import UpArrow from "../../images/UpArrow.svg"
import DownArrow from "../../images/DownArrow.svg";
import InfoIcon from "../../memberSearch/InfoIcon.svg";

export default class PaymentTableData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adjustmentDetails: []
    };
  }

  componentDidMount() {
    this.setState({
      adjustmentDetails: this.props.adjustmentDetails ? this.props.adjustmentDetails
        : this.props.service && this.props.service.adjustmentDetails ? this.props.service.adjustmentDetails : []
    })
  }

  render() {
    return (
      <Row style={{width:"100%"}}>
        {/* {this.props.direction === "up" && this.props.selIndex === index && */}
        <Col span={24} className={`pb-3 servicesCodes ${this.props.isClaimLevelPriced === "True" && this.props.claimNumber[0] === "I" ? "" : "actionInServices"}`}>
          {this.state.adjustmentDetails && this.state.adjustmentDetails.map((item, index) => {
            return (
              <Row className="mt-3 mx-4">
                <Col span={6}>
                  <div>
                    <span className="details-header-row pr-3">Group Code:</span>
                    <span className="black-text font-12">{item.groupCode ? item.groupCode : "---"}</span>
                    {item.groupCode && <span className="ml-3">
                      <Tooltip title={item.groupCodeDescription} placement="topLeft" align="left">
                        <img
                          src={InfoIcon}
                          alt="info ifon"
                          onClick={() => this.showModal("perAuth")}
                        />
                      </Tooltip>
                    </span>}

                  </div>
                </Col>
                <Col span={6}>
                  <div>
                    <span className="details-header-row pr-3 ">Reason Code:</span>
                    <span className="black-text font-12">{item.reasonCode ? item.reasonCode : "---"}</span></div>
                </Col>
                <Col span={6}>
                  <div>
                  <span className="details-header-row pr-3">Remark Code:</span>
                  <span className="black-text font-12">{item.remarkCode ? item.remarkCode : "---"}</span>
                    {item.remarkCode && <span className="ml-3">
                      <Tooltip title={item.remarkCodeDescription} placement="topLeft" align="left">
                        <img
                          src={InfoIcon}
                          alt="info ifon"
                          onClick={() => this.showModal("perAuth")}
                        />
                      </Tooltip>
                    </span>}

                  </div>
                </Col>
                <Col span={6}>
                  <div>
                    <span className="details-header-row pr-3 ">Adjustment Amount:</span>
                    <span className="black-text font-12">{item.adjustmentAmount ? '$ ' + item.adjustmentAmount : "---"}</span></div>
                </Col>
                <Col span={24} className="pt-3">
                  <div><span className="details-header-row pr-3">Reason:</span>
                  <span className="black-text font-12">
                    {item.reasonCodeDescription ? 
                      item.reasonCodeDescription : "---"
                      // <Tooltip
                      //   title={item.reasonCodeDescription}
                      //   placement="topLeft"
                      //   align="left"
                      // >
                      //   {item.reasonCodeDescription}
                      // </Tooltip>
                    }</span>
                  </div>
                  {/* <div>
                    {item.reasonCodeDescription ? item.reasonCodeDescription : "---"}
                  </div> */}
                </Col>
                {this.state.adjustmentDetails.length - 1 > index && <Col className="pb-2 mt-3" span={24} style={{ borderTop: "1px solid #e2edff" }}>
                  <span></span>
                </Col>}
              </Row>
            )
          })}

        </Col>
      </Row>
    );
  }
}
